// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qQnu","icon":"styles_icon__1kEHQ"};